import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormGroup, FormControl, ControlLabel, Radio, Form } from 'react-bootstrap';

const DELIMITER_OPTIONS = [
  { label: 'Comma', value: ',' },
  { label: 'Tab', value: '\t' },
  { label: 'Colon', value: ':' },
  { label: 'Semi-Colon', value: ';' },
];

class DelimiterOption extends Component {
  constructor(props) {
    super(props);
    this._onChange = this._onChange.bind(this);
  }

  _onChange() {
    this.props.onChange(this.props.value);
  }

  render() {
    const { label, selected } = this.props;

    return (
      <Radio
        onChange={this._onChange}
        name='delimiter'
        checked={selected}
      >{label}</Radio>
    );
  }
}

DelimiterOption.propTypes = {
  onChange: PropTypes.func,
  label: PropTypes.string,
  selected: PropTypes.bool,
  value: PropTypes.string,
};

class ExporterForm extends Component {
  constructor(props) {
    super(props);
    this._onNameChange = this._onNameChange.bind(this);
    this._onQueryChange = this._onQueryChange.bind(this);
  }

  _onNameChange(e) {
    this.props.onNameChange(e.target.value);
  }

  _onQueryChange(e) {
    this.props.onQueryChange(e.target.value);
  }

  render() {
    const { query, name, delimiter, onDelimiterChange } = this.props;
    return (
      <Form>
        <FormGroup controlId='jobName'>
          <ControlLabel>Job Name</ControlLabel>
          <FormControl
            type='text'
            value={name}
            onChange={this._onNameChange}
          />
        </FormGroup>
        <FormGroup controlId='query'>
          <ControlLabel>Database Query</ControlLabel>
          <FormControl
            componentClass='textarea'
            placeholder='select * from table'
            value={query}
            onChange={this._onQueryChange}
          />
        </FormGroup>
        <FormGroup controlId='delimiter'>
          <ControlLabel>Output File Delimiter</ControlLabel>
          {DELIMITER_OPTIONS.map(option => (
            <DelimiterOption
              key={option.value}
              value={option.value}
              onChange={onDelimiterChange}
              label={option.label}
              selected={delimiter === option.value}
            />
          ))}
        </FormGroup>
      </Form>
    );
  }
}

ExporterForm.propTypes = {
  query: PropTypes.string,
  name: PropTypes.string,
  delimiter: PropTypes.string,
  onDelimiterChange: PropTypes.func,
  onNameChange: PropTypes.func,
  onQueryChange: PropTypes.func,
};

export default ExporterForm;
